const RAND_CHARSET_AZ_U = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const RAND_CHARSET_AZ_L = "abcdefghijklmnopqrstuvwxyz";
const RAND_CHARSET_09 = "0123456789";
const RAND_CHARSET_AZ09_U = RAND_CHARSET_AZ_U + RAND_CHARSET_09;
const RAND_CHARSET_AZ09_L = RAND_CHARSET_AZ_L + RAND_CHARSET_09;
const RAND_CHARSET_AZ09_UL = RAND_CHARSET_AZ_L + RAND_CHARSET_AZ_U + RAND_CHARSET_09;
const RAND_CHARSET_AZ_UL = RAND_CHARSET_AZ_L + RAND_CHARSET_AZ_U;
const RAND_CHARSET_HEX_U = RAND_CHARSET_09 + "ABCDEF";
const RAND_CHARSET_HEX_L = RAND_CHARSET_09 + "abcdef";
const DEFAULT_RANDOM_CHARSET = RAND_CHARSET_AZ09_UL;
function randomString(length, charset = DEFAULT_RANDOM_CHARSET) {
  const l = charset.length;
  let result = "";
  if (length <= 0) {
    return result;
  }
  while (length-- > 0) {
    result += charset[Math.floor(Math.random() * l)];
  }
  return result;
}
export {
  DEFAULT_RANDOM_CHARSET,
  RAND_CHARSET_09,
  RAND_CHARSET_AZ09_L,
  RAND_CHARSET_AZ09_U,
  RAND_CHARSET_AZ09_UL,
  RAND_CHARSET_AZ_L,
  RAND_CHARSET_AZ_U,
  RAND_CHARSET_AZ_UL,
  RAND_CHARSET_HEX_L,
  RAND_CHARSET_HEX_U,
  randomString
};
//# sourceMappingURL=RandomString.js.map
